import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import "../../styles/index.css";
import axios from "../../../axios";
import { toast } from "react-toastify";
/**
 * Shows the join now event on day view
 * @param {} param0
 * @returns
 */
//Pending work here I have implemented the join now feature by taking reference from documentaion but it is not verified because I am not getting the bbb lecture id in events.
const TimeTableJoinNow = ({ event }) => {
  const navigate = useNavigate();
  let _id;
  const userData = JSON.parse(localStorage.getItem("breathForStudent"));
  const [joinNow, setJoinNow] = useState(false);
  useEffect(() => {
    event.Events.forEach((element) => {
      if (element.name === "bbb_lecture") {
        setJoinNow(true);
      }
    });
  }, [event]);
  const foundItem = event?.Events?.find(item => item.name === "bbb_lecture");
  const onJoinNowClick = async (e) => {
    e.stopPropagation();
    const data = JSON.parse(localStorage.getItem("breathForStudent"));
    event.Events.forEach((element) => {
      if (element.name === "bbb_lecture") {
        setJoinNow(true);
        _id = element.value;
      }
    });
    try {
      const res = await axios.get(
        `/videoConference/classes/join/${_id}?viewer_name=${data?.name}&user_id=${userData.id}`
      );

      if (res.data.data) {
        const win = window.open(res.data.data, "_blank");
        if (win) win.focus();
      }
    } catch (error) {
      console.error("Join class error:", error);
      toast.error("Meeting is not started!!");
    }
  };
  return event.Events[0] !== "Planner" ? (
    foundItem && <div className="summary_con col mt-1">
      <button className="Join_button" onClick={(e) => onJoinNowClick(e)} ><div className="jnwContain"><p style={{ color: `${event?.DisplayColor}` }} className="jnwtxt">JOIN NOW</p></div></button>
    </div>
  ) : (
    <div className="summary_con col">
      {/* <button className="edtbtn">Edit Planner</button> */}
    </div>
  );
};

export default TimeTableJoinNow;
